'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import Icon from '@/components/ui/AppIcon';

const navLinks = [
  { label: 'Home', href: '/homepage' },
  { label: 'Kavling', href: '/kavling' },
  { label: 'Project', href: '/projects' },
  { label: 'Cara Membeli', href: '/cara-membeli' },
  { label: 'Tentang Kami', href: '/tentang-kami' },
  { label: 'Insight', href: '/insight' },
];

export default function PublicHeader() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-card border-b border-border shadow-topbar">
      <div className="max-w-screen-2xl mx-auto px-4 lg:px-8 xl:px-10 2xl:px-16 h-16 flex items-center justify-between gap-4">
        <Link href="/homepage" className="flex items-center gap-2 flex-shrink-0">
          <AppLogo size={36} />
          <span className="font-bold text-lg text-primary tracking-tight hidden sm:block">
            Betaland<span className="text-accent">.ID</span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {navLinks?.map((link) => (
            <Link
              key={`nav-${link?.href}`}
              href={link?.href}
              className="px-3 py-2 text-sm font-medium text-muted-foreground hover:text-primary hover:bg-muted rounded-lg transition-colors duration-150"
            >
              {link?.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            href="/jadi-partner"
            className="hidden md:flex items-center gap-1.5 px-4 py-2 border-2 border-primary text-primary text-sm font-semibold rounded-lg hover:bg-primary hover:text-white transition-colors duration-150"
          >
            <Icon name="UserPlusIcon" size={15} />
            Jadi Partner
          </Link>
          <Link
            href="/login"
            className="hidden md:flex items-center gap-1.5 px-4 py-2 border border-border text-muted-foreground text-sm font-medium rounded-lg hover:bg-muted transition-colors duration-150"
          >
            <Icon name="ArrowRightOnRectangleIcon" size={15} />
            Login Agent/Admin
          </Link>
          <a
            href="https://wa.me/6281282760110"
            target="_blank"
            rel="noopener noreferrer"
            className="hidden sm:flex items-center gap-2 px-4 py-2 bg-primary text-primary-foreground text-sm font-semibold rounded-lg hover:bg-primary-dark transition-colors duration-150 active:scale-95"
          >
            <Icon name="ChatBubbleLeftRightIcon" size={16} />
            WhatsApp
          </a>
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="lg:hidden p-2 rounded-lg hover:bg-muted transition-colors"
            aria-label="Toggle menu"
          >
            <Icon name={mobileOpen ? 'XMarkIcon' : 'Bars3Icon'} size={22} />
          </button>
        </div>
      </div>
      {mobileOpen && (
        <div className="lg:hidden border-t border-border bg-card fade-in">
          <nav className="px-4 py-3 flex flex-col gap-1">
            {navLinks?.map((link) => (
              <Link
                key={`mobile-nav-${link?.href}`}
                href={link?.href}
                onClick={() => setMobileOpen(false)}
                className="px-3 py-2.5 text-sm font-medium text-foreground hover:text-primary hover:bg-muted rounded-lg transition-colors"
              >
                {link?.label}
              </Link>
            ))}
            <Link
              href="/jadi-partner"
              onClick={() => setMobileOpen(false)}
              className="px-3 py-2.5 text-sm font-semibold text-primary hover:bg-muted rounded-lg transition-colors flex items-center gap-2"
            >
              <Icon name="UserPlusIcon" size={16} /> Jadi Partner
            </Link>
            <Link
              href="/login"
              onClick={() => setMobileOpen(false)}
              className="px-3 py-2.5 text-sm font-medium text-muted-foreground hover:bg-muted rounded-lg transition-colors flex items-center gap-2"
            >
              <Icon name="ArrowRightOnRectangleIcon" size={16} /> Login Agent/Admin
            </Link>
            <a
              href="https://wa.me/6281234567890"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-2 flex items-center justify-center gap-2 px-4 py-2.5 bg-primary text-primary-foreground text-sm font-semibold rounded-lg"
            >
              <Icon name="ChatBubbleLeftRightIcon" size={16} />
              Hubungi Kami via WhatsApp
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}